export const mutationType = {
  SEND_REGISTER_FORM: 'SEND_REGISTER_FORM',
  GET_USER_ID: 'GET_USER_ID',
}
